module.exports = __webpack_public_path__ + "static/media/banner_alibaba_ss.8a21748a.jpg";